import _extends from '@babel/runtime/helpers/extends';
import cx from 'classnames';
import React__default from 'react';
import PropTypes from 'prop-types';

const BASE_CLASS = 'nui-dialog-actions';
function DialogActions({
  children,
  className,
  ...rest
}) {
  return /*#__PURE__*/React__default.createElement("div", _extends({
    className: cx(BASE_CLASS, className)
  }, rest), children);
}
DialogActions.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
DialogActions.displayName = 'NuiDialogActions';

export { BASE_CLASS, DialogActions as default };
